export enum OperateType {
  GENERATE_OUTLINE = 'GENERATE_OUTLINE',
  GENERATE_QUESTION = 'GENERATE_QUESTION',
  ANALYSIS_AND_PROCESS = 'ANALYSIS_AND_PROCESS',
  ABBREVIATION = 'ABBREVIATION',
  CREATEIMAGE = 'CREATEIMAGE',
  ACRONYM = 'ACRONYM',
  FORMAL_TONE_REWRITE = 'FORMAL_TONE_REWRITE',
  INFORMAL_TONE_REWRITE = 'INFORMAL_TONE_REWRITE',
  PARAGRAPH_GENERATE = 'PARAGRAPH_GENERATE',
  ARTICLE_GENERATE = 'ARTICLE_GENERATE',
  TEXT_OPTIMIZATION = 'TEXT_OPTIMIZATION',
}

export interface AiWriterOption {
  title?: string
  operateType: OperateType
  outline?: string
  question?: string
  data?: string
  tone?: 'bullish' | 'bearish' | 'neutral'
  wordsLimit?: string
  text?: string
  traceId?: string
  character?: string // 人设的名称
}

export interface CallBack {
  openCb?: () => void
  msgCb?: (data: any) => void
  closeCb?: () => void
  errorCb?: () => void
}

export enum AiStatus {
  ERROR = -1,
  DEFAULT = 0,
  OPEN = 1,
  WRITING = 2,
  END = 3,
  USER_CLOSE = 4,
}

export interface DataEvent {
  text?: string // 文本内容
  prompt?: string // 模型prompt
}

export enum GenerateType {
  OVERRIDE = 'OVERRIDE', // 覆盖
  GENE_IN_MAIN = 'GENE_IN_MAIN', // 生成在页面
  GENE_IN_SIDE = 'GENE_IN_SIDE', // 生成在侧边栏
  NO = 'NO', // 没生成
}

export type GenerateData = {
  leftIsEmpty: boolean
  type: GenerateType
}

export interface AiWriterProps {
  dependOnUser?: boolean // 调用者自己处理信息，hook内部不需要处理
  delayTime?: number // 打字机间隔时间
  askDelayMsgCb?: (content: string) => void // 打字机内容获取回调，与真实内容存在延迟，解决useEffect慢的问题
}
